import SchemaMarkup from "../Components/SchemaMarkup";

const BookAppointmentSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",

    "@id": "https://msayurved.com/book-appointment/#webpage",

    "url": "https://msayurved.com/book-appointment/",

    "name": "Book an Ayurvedic Appointment | Dr. Jigar Gor",

    "description":
      "Book an appointment with Dr. Jigar Gor for Ayurvedic consultation and personalized Ayurvedic treatment in Bhuj, Kutch, Gujarat.",

    "isPartOf": {
      "@id": "https://msayurved.com/#website"
    },

    "about": {
      "@id": "https://msayurved.com/#medicalclinic"
    },

    "mainEntity": {
      "@id": "https://msayurved.com/#medicalclinic"
    },

    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default BookAppointmentSchema;